import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import trans from 'translate';
import { connect } from 'react-redux';
import ModalBody from '../ModalBody';
import { Button } from '../../Common';
import { usePromise } from '../../../hooks/usePromise/usePromise';
import { signTypedDataV4 } from '../../../services/web3Service';
import { getSignatureConfig, typesMapper } from '../../../services/hpoolService';
import { getWhitelisted, getWhitelistedPoolsForUser } from '../../../services/vpoolService';
import { objectMapper } from '../../../utils/mapper';
import { combineLoadingMsgs } from '../../../utils/format';
import { getWhitelistedPools } from '../../../redux/actions/createHPoolActions';
import './GetWhitelistedModal.scss';

const GetWhitelistedModal = ({ closeModal, hpool, poolId: poolViewId, account, getWhitelistedPools, modalProps }) => {
  const [sign, , signing] = usePromise(signTypedDataV4, { showError: true });
  const [sendSignature, , sendingLoading] = usePromise(getWhitelisted, {
    showError: true,
    showSuccess: trans('vpool.whitelist_success_msg'),
  });

  const currentLoading = combineLoadingMsgs([
    { isLoading: signing, loadingText: 'Signing' },
    { isLoading: sendingLoading, loadingText: 'Sending Signature' },
  ]);

  const handleSuccess = () => {
    getWhitelistedPools(account).then(closeModal);
  };

  const handleSignature = async () => {
    // let poolId = 0; // poolId will be passed =>

    // const { web3_hpool_id: web3Id, id } = hpool || {}; // either by hpool state (as in PhaseStatus)
    const { poolId: passedPoolId } = modalProps || {}; // or in pool list (passed in modal props)
    const poolId = poolViewId || passedPoolId;
    const { type, primaryType } = getSignatureConfig('Whitelist');

    const msg = {
      poolId,
      userAddress: account,
    };

    const signature = await sign(msg, type, primaryType, true);
    const mappedForRequest = objectMapper(msg, { userAddress: 'wallet_address', poolId: 'vpool_id' });
    mappedForRequest.vpool_id = poolId;
    if (!signature) return;
    sendSignature({
      ...mappedForRequest,
      signature,
    }).then(handleSuccess);
  };

  return (
    <div className="whitelist-wrapper">
      <ModalBody title="modal.get_whitelist" closeModal={closeModal}>
        <span className="font-light d-block mb-4">{trans('vpool.whitelist_request')}</span>
        <Button
          text="common.sign"
          className="green"
          loadingText={currentLoading.loadingText}
          onClick={handleSignature}
          loading={currentLoading.isLoading}
          requireWallet
        />
      </ModalBody>
    </div>
  );
};

const mapStateToProp = ({ createHPool, wallet, modal }) => ({
  hpool: createHPool.hpool,
  account: wallet.account,
  modalProps: modal.modalProps,
});

const mapDispatchToProps = {
  getWhitelistedPools,
};

GetWhitelistedModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  getWhitelistedPools: PropTypes.func.isRequired,
  hpool: PropTypes.object.isRequired,
  account: PropTypes.string.isRequired,
  modalProps: PropTypes.object.isRequired,
  poolId: PropTypes.number.isRequired,
};

export default connect(mapStateToProp, mapDispatchToProps)(GetWhitelistedModal);
